/**
 * Directional orbit down (descending spiral) gesture
 * @module gestures/transforms/orbitDown
 */
import { createOrbitGesture } from './orbitFactory.js';
export default createOrbitGesture('down');
